import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/file-pdf.svg'
import _imports_1 from '../assets/has.png'
import _imports_2 from '../assets/inc.png'
import _imports_3 from '../assets/asccp.png'


const _withScopeId = n => (_pushScopeId("data-v-cb721f08"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ref-container" }
const _hoisted_2 = ["href"]
const _hoisted_3 = { class: "header" }
const _hoisted_4 = { class: "line" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_6 = { class: "line" }
const _hoisted_7 = {
  key: 0,
  src: _imports_1
}
const _hoisted_8 = {
  key: 1,
  src: _imports_2
}
const _hoisted_9 = {
  key: 2,
  src: _imports_3
}
const _hoisted_10 = ["href"]
const _hoisted_11 = { class: "header" }
const _hoisted_12 = { class: "line" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_14 = { class: "line" }
const _hoisted_15 = {
  key: 0,
  src: _imports_1
}
const _hoisted_16 = {
  key: 1,
  src: _imports_2
}
const _hoisted_17 = {
  key: 2,
  src: _imports_3
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.isMobile())
      ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          href: `${_ctx.url}`,
          target: "blank"
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("p", null, _toDisplayString(_ctx.type), 1)
            ]),
            _createElementVNode("div", _hoisted_6, [
              (_ctx.source === 'has')
                ? (_openBlock(), _createElementBlock("img", _hoisted_7))
                : _createCommentVNode("", true),
              (_ctx.source === 'inca')
                ? (_openBlock(), _createElementBlock("img", _hoisted_8))
                : _createCommentVNode("", true),
              (_ctx.source === 'asccp')
                ? (_openBlock(), _createElementBlock("img", _hoisted_9))
                : _createCommentVNode("", true),
              _createElementVNode("p", null, _toDisplayString(_ctx.year), 1)
            ])
          ]),
          _createElementVNode("p", null, _toDisplayString(_ctx.content), 1)
        ], 8, _hoisted_2))
      : (_openBlock(), _createElementBlock("a", {
          key: 1,
          href: 'medics://viewer?m_source=' + _ctx.url
        }, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createElementVNode("p", null, _toDisplayString(_ctx.type), 1)
            ]),
            _createElementVNode("div", _hoisted_14, [
              (_ctx.source === 'has')
                ? (_openBlock(), _createElementBlock("img", _hoisted_15))
                : _createCommentVNode("", true),
              (_ctx.source === 'inca')
                ? (_openBlock(), _createElementBlock("img", _hoisted_16))
                : _createCommentVNode("", true),
              (_ctx.source === 'asccp')
                ? (_openBlock(), _createElementBlock("img", _hoisted_17))
                : _createCommentVNode("", true),
              _createElementVNode("p", null, _toDisplayString(_ctx.year), 1)
            ])
          ]),
          _createElementVNode("p", null, _toDisplayString(_ctx.content), 1)
        ], 8, _hoisted_10))
  ]))
}